export const isWebAuthnSecureContext = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    if (!('PublicKeyCredential' in window)) {
        return false;
    }

    const isLocalhost = window.location.hostname === 'localhost';
    return window.isSecureContext || isLocalhost;
};

export const webAuthnDisabledReason = 'WebAuthn benötigt HTTPS (außer localhost)';
